'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var _preludeExtension = require('prelude-extension');

var _unidecode = require('unidecode');

var _unidecode2 = _interopRequireDefault(_unidecode);

var _terms = require('redux/modules/terms');

var termActions = _interopRequireWildcard(_terms);

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TermsBox = (_dec = (0, _reactRedux.connect)(null, (0, _extends3.default)({}, termActions)), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(TermsBox, _Component);

  function TermsBox() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TermsBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TermsBox.__proto__ || (0, _getPrototypeOf2.default)(TermsBox)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      ajax: null,
      items: [],
      loaded: false,
      loading: false,
      selectedItems: [],
      selectedTerms: []
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TermsBox, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        selectedTerms: nextProps.selectedTerms,
        selectedItems: nextProps.selectedTerms.map(function (term) {
          return {
            value: term.id,
            label: term.name
          };
        })
      });
    }
  }, {
    key: 'onSearchChange',
    value: function onSearchChange(input) {
      var _this2 = this;

      var query = input.trim();
      var ajax = this.state.ajax;


      if (ajax) {
        clearTimeout(ajax);
      }

      this.setState({
        ajax: setTimeout(function () {
          _this2.loadTerms(query);
        }, 250),
        loaded: false
      });
    }
  }, {
    key: 'onValuesChange',
    value: function onValuesChange(values) {
      var _this3 = this;

      this.setState({
        selectedItems: values
      }, function () {
        var onChange = _this3.props.onChange;

        var terms = _this3.getTermFromValues(_this3.state.selectedItems);
        onChange(terms);
      });
    }
  }, {
    key: 'getTermFromValues',
    value: function getTermFromValues(values) {
      var _this4 = this;

      return values.map(function (item) {
        if (item.value === item.label) {
          return { name: item.label };
        }
        return {
          id: item.value,
          name: item.label,
          taxonomy_id: _this4.props.taxonomy.id
        };
      });
    }
  }, {
    key: 'loadTerms',
    value: function loadTerms(query) {
      var _this5 = this;

      if (query.length > 2) {
        this.setState({
          ajax: null,
          loading: true
        }, function () {
          _this5.props.search(query, _this5.props.taxonomy.id).then(function (terms) {
            var typesRendered = terms.result.data.map(function (term) {
              return {
                value: term.id,
                label: term.name,
                labelPartitions: (0, _preludeExtension.partitionString)((0, _unidecode2.default)(term.name).toLowerCase(), (0, _unidecode2.default)(query).toLowerCase())
              };
            });
            _this5.setState({
              items: typesRendered,
              loaded: !_this5.state.ajax,
              loading: false
            });
          });
        });
      } else if (query.length <= 2) {
        this.setState({
          items: []
        });
      } else {
        this.state.items.map(function (type) {
          type.labelPartitions = (0, _preludeExtension.partitionString)((0, _unidecode2.default)(type.label).toLowerCase(), (0, _unidecode2.default)(query).toLowerCase());
        });
      }
    }
  }, {
    key: 'filterOptions',
    value: function filterOptions(options, values, query) {
      return options.filter(function (option) {
        var inValues = values.filter(function (value) {
          return option.value === value.value;
        });
        var label = (0, _unidecode2.default)(option.label).toLowerCase().trim();
        var queryTyped = (0, _unidecode2.default)(query).toLowerCase().trim();
        return !inValues.length && label.indexOf(queryTyped) > -1;
      });
    }
  }, {
    key: 'handleExitPopover',
    value: function handleExitPopover() {
      var onChange = this.props.onChange;

      var terms = this.getTermFromValues(this.state.selectedItems);

      onChange(terms);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var _props = this.props,
          errors = _props.errors,
          polyglot = _props.polyglot,
          popoverContainer = _props.popoverContainer,
          taxonomy = _props.taxonomy;
      var selectedTerms = this.state.selectedTerms;


      var boxUI = selectedTerms.length <= 0 ? _react2.default.createElement(TermsBox.Empty, { name: taxonomy.name, errors: errors }) : _react2.default.createElement(TermsBox.HasTerms, { polyglot: polyglot, terms: selectedTerms, errors: errors });

      return _react2.default.createElement(
        _reactBootstrap.OverlayTrigger,
        {
          ref: 'termsBoxOverlayTrigger',
          trigger: 'click',
          placement: 'top',
          rootClose: true,
          container: popoverContainer,
          onExit: this.handleExitPopover.bind(this),
          overlay: _react2.default.createElement(
            _reactBootstrap.Popover,
            { id: 'termsBoxPopover', className: 'terms-box-popover' },
            _react2.default.createElement(
              'div',
              { className: 'form-group' },
              _react2.default.createElement(
                'label',
                { htmlFor: 'activity-search' },
                polyglot.t('events.termsBox.add', { key: taxonomy.name.toLocaleLowerCase() })
              ),
              _react2.default.createElement(_reactSelect2.default, {
                isMulti: true,
                autoFocus: true,
                className: 'react-select',
                classNamePrefix: 'react-select',
                options: this.state.items,
                value: this.state.selectedItems,
                onInputChange: this.onSearchChange.bind(this),
                onChange: this.onValuesChange.bind(this),
                placeholder: polyglot.t('simpleSelect.select'),
                noOptionsMessage: function noOptionsMessage(search) {
                  var values = _this6.state.selectedItems;
                  var query = search.inputValue.trim();
                  var noResultsText = '';
                  if (_this6.state.loading) {
                    noResultsText = 'Chargement...';
                  } else if (values.map(function (value) {
                    return value.label;
                  }).indexOf(query) !== -1) {
                    noResultsText = 'Le terme existe déjà.';
                  } else {
                    noResultsText = 'Aucun résultat';
                  }
                  return _react2.default.createElement(
                    'div',
                    { className: 'no-results-found' },
                    noResultsText
                  );
                }
              }),
              _react2.default.createElement(
                'p',
                { className: 'help-block' },
                polyglot.t('events.termsBox.help')
              )
            )
          )
        },
        boxUI
      );
    }
  }], [{
    key: 'Empty',
    value: function Empty(_ref2) {
      var name = _ref2.name,
          onClick = _ref2.onClick,
          errors = _ref2.errors;

      return _react2.default.createElement(
        'div',
        { className: 'terms-box empty dashed-box' + (errors.length > 0 ? ' has-error' : ''), onClick: onClick },
        _react2.default.createElement('span', { className: 'icon-cg-link left-icon' }),
        _react2.default.createElement(
          'label',
          null,
          name
        )
      );
    }
  }, {
    key: 'HasTerms',
    value: function HasTerms(_ref3) {
      var onClick = _ref3.onClick,
          terms = _ref3.terms,
          errors = _ref3.errors;

      return _react2.default.createElement(
        'div',
        { className: 'terms-box empty line-box event-content-box' + (errors.length > 0 ? ' has-error' : ''), onClick: onClick },
        _react2.default.createElement(TermsBox.SelectedTerms, { terms: terms })
      );
    }
  }, {
    key: 'SelectedTerms',
    value: function SelectedTerms(_ref4) {
      var terms = _ref4.terms;

      var termsUI = terms.map(function (term, index) {
        return _react2.default.createElement(
          'span',
          { key: index, className: 'label label-default' },
          term.name
        );
      });
      return _react2.default.createElement(
        'span',
        null,
        termsUI
      );
    }
  }]);
  return TermsBox;
}(_react.Component), _class2.propTypes = {
  errors: _propTypes2.default.array.isRequired,
  polyglot: _propTypes2.default.object.isRequired,
  popoverContainer: _propTypes2.default.any,
  onChange: _propTypes2.default.func,
  selectedTerms: _propTypes2.default.array,
  search: _propTypes2.default.func.isRequired,
  taxonomy: _propTypes2.default.object.isRequired
}, _class2.contextTypes = {
  store: _propTypes2.default.object.isRequired
}, _temp2)) || _class);
exports.default = TermsBox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/TermsBox.js
// module id = 2223
// module chunks = 0